import React, { useMemo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Typography,
  Button,
  Box,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import LocationRow from "./LocationRow";
import { groupBy } from "./utils/tableHelpers";

export default function LocationsCollapseTable({
  locations = [],
  buildings = [],
  departments = [],
  rooms = [],
  getLocationTypeName,
  locationTypes = [],
  departmentTypes = [],
  roomTypes = [],
  floorTypes = [],
  onCreateLocation,
  onSaveLocation,
  onSaveBuilding,
  onSaveDepartment,
  onSaveRoom,
  height = 520,
}) {
  const [openLocationId, setOpenLocationId] = useState(null);

  const buildingsByLocation = useMemo(
    () => groupBy(buildings, "location_pk_id"),
    [buildings],
  );

  const departmentsByBuilding = useMemo(
    () => groupBy(departments, "building_pk_id"),
    [departments],
  );

  const roomsByDepartment = useMemo(
    () => groupBy(rooms, "department_pk_id"),
    [rooms],
  );

  return (
    <>
      <TableContainer
        component={Paper}
        sx={{ maxHeight: height, overflow: "auto" }}
      >
        <Table stickyHeader={false} size="small" aria-label="locations table">
          <TableBody>
            {locations.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4}>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ py: 1 }}
                  >
                    No locations found.
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              locations.map((loc) => (
                <LocationRow
                  key={loc.pk_id}
                  location={loc}
                  buildingsByLocation={buildingsByLocation}
                  getLocationTypeName={getLocationTypeName}
                  locationTypes={locationTypes}
                  departmentTypes={departmentTypes}
                  roomTypes={roomTypes}
                  floorTypes={floorTypes}
                  onSaveLocation={onSaveLocation}
                  onSaveBuilding={onSaveBuilding}
                  departmentsByBuilding={departmentsByBuilding}
                  roomsByDepartment={roomsByDepartment}
                  onSaveDepartment={onSaveDepartment}
                  onSaveRoom={onSaveRoom}
                  isOpen={openLocationId === loc.pk_id}
                  onToggle={() =>
                    setOpenLocationId(
                      openLocationId === loc.pk_id ? null : loc.pk_id,
                    )
                  }
                />
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Create New Location Button */}
      <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-start" }}>
        <Button
          variant="outlined"
          startIcon={<AddIcon />}
          onClick={onCreateLocation}
          size="small"
          sx={{
            borderColor: "primary.main",
            color: "primary.main",
            "&:hover": {
              borderColor: "primary.dark",
              backgroundColor: "primary.light",
            },
          }}
        >
          Create New Location
        </Button>
      </Box>
    </>
  );
}
